import React from 'react';
import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { IconProps } from '@jbhi-fi/lanyard-ui/components/Icon/CustomIcon';

const DownloadIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.667"
        d="M18,10 L18,18 L2,18 L2,10 M6,8.66666667 L10,12.6666667 L14,8.66666667 M10,12.6666667 L10,2"
      />
    </>
  ),
  defaultProps: { width: '20px', height: '20px' },
});

export const PerksDownloadIcon: React.FC<IconProps> = ({...props }) => {
  return <DownloadIcon {...props}  />;
};
